import React from 'react'
import dayjs from 'dayjs'
import { Progress, Tooltip, Popover } from 'antd'
import { CampaignTargetType, CampaignType, Scalars } from '../../../../__generated__/graphql'

const round = (number: number) => Math.round(number * 100) / 100

const getPacing = (currentValue: number, targetValue: number, startDate: Scalars['DateTime'], endDate: Scalars['DateTime']) => {
  if (targetValue === 0) {
    return null
  }

  const totalPeriod = dayjs(endDate).diff(dayjs(startDate), 'h')
  const passedPeriod = Math.min(dayjs().diff(dayjs(startDate), 'h'), totalPeriod)

  return round((currentValue * 100 / (targetValue / totalPeriod * passedPeriod)))
}

const getCurrentValue = (record: any) => {
  switch (record.targetType) {
    case CampaignTargetType.Impressions:
      return {value: record.impressions, unit: 'impressions'}
    case CampaignTargetType.Reads:
      return {value: record.reads, unit: 'reads'}
    case CampaignTargetType.Clickouts:
      return {value: record.clicks, unit: 'clicks'}
    default:
      return {value: record.cost, unit: 'DKK'}
  }
} 

const getColor = (percent: number) => {
  if (percent < 75 || percent >= 110) {
    return '#ff4d4f'
  }

  if (percent >= 90 && percent < 105) {
    return '#52c41a'
  }

  return '#faad14'
}

interface PacingCellProps {
  record: any;
  hidden: boolean;
}

const PacingCell: React.FC<PacingCellProps> = ({ record, hidden }) => {
  const NOT_AVAILABLE = <span className='text-sm text-gray-400'>N/A</span>
  
  if (hidden) {
    return NOT_AVAILABLE
  }

  if (record.type === CampaignType.Filler) {
    return <Tooltip title='Not applicable for filler campaigns'>
      {NOT_AVAILABLE}
    </Tooltip>
  }
  
  const {targetValue, targetType, startDate, endDate} = record
  const {value, unit} = getCurrentValue(record)
  const pacing = getPacing(value, targetValue, startDate, endDate)

  const pacingData = targetType !== CampaignTargetType.Budget ? (
    <>
      {pacing !== null && <div>Current: {value} {unit}</div>}
      <div>Target: {targetValue} {unit}</div>
    </>
  ) : null
  return <Popover
    content={
      <>
        {pacing !== null && <div>Pacing: {pacing}%</div>}
        {pacingData}
      </>
    }
    placement='bottom'
  >
    {pacing !== null && <Progress showInfo={false} type='circle' size={24} percent={pacing} strokeColor={getColor(pacing)} />}
    {pacing === null && <span className='text-sm text-gray-400'>N/A</span>}
  </Popover>
};

export default PacingCell;


